module.exports = __webpack_public_path__ + "img/ailab1.a24b1ebf.png";